/*
 * The team a slot booking belongs to, by team name (employee.name).
 *
 * getSlotBookings returns team_name for this. nick_name used to double as the
 * team label, but it is now the team's serviceman-app username and can differ
 * from the name that slots, schedules and Assigned To are keyed on.
 */
export const bookingTeamName = (booking) => booking?.team_name ?? booking?.nick_name ?? undefined;

export default bookingTeamName;
